<template>
  <el-row class="editPanel">
    <h3 :class="{closed: !panelOpen}">Documents</h3><span class="toggle" @click="panelOpen = panelOpen !== true" :class="{closed: !panelOpen}"></span>
    <transition name="panel">
      <div class="pea-panel" v-if="panelOpen">
        <el-form ref="documentsForm" :model="docMeta" key="docKey" :rules="rules">
          <h4>Costing Documents</h4>
          <p>
            You should provide at least 3 quotes for all planned expenditures. If necessary, you may upload multiple documents to achieve this. If this is not applicable, please describe why in the Upload Notes/Comments field.<br/>
            Before contacting external suppliers you should check that the item/capacity is not available internally within TFX. See the Checks section below - "Global Sourcing" and "Available Internally Within TFX" for more details.
          </p>
          <p v-if="usingIE" class="IEwarn">
            <strong> Please SAVE file when prompted in IE, do not open directly.
            </strong>
          </p>
          <el-row :gutter="20">
            <el-col :span="22">
              <el-form-item class="doc-list">
                <el-upload class="doc-upload" :disabled="disabled" ref="FileUploadCosting" v-bind:action="this.apiPath + '/pea/' + this.peaId + '/addDocument/Costing'"
                    :headers="checkReturnAuthHead" v-loading="isCostLoading" :on-success="uploadCostingSuccess" :on-error="uploadCostingFailure" :before-upload="startUploadCosting" :file-list="CostingDocumentFiles" :on-remove="removeFile" :on-preview="downloadDocument">
                  <el-button class="doc-submit" :disabled="isCostLoading || disabled" v-if="!disabled" slot="trigger" type="primary">Select &amp; Upload Costing</el-button>
                </el-upload>
              </el-form-item>
              <strong>{{this.MaxFileSizeMessage}}</strong>
              <br v-if="isCostLoading"/>
              <span v-if="isCostLoading">{{this.costLoadingMessage}}</span>
              <span class="el-icon-loading" v-if="isCostLoading"></span>
              <span v-if="!isCostLoading">&nbsp;</span>
            </el-col>
            <!-- <el-col :span="1">
              <tool-tip-popup text="Note: You can attach multiple Costing documents."></tool-tip-popup>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="costDesc" label="Costing Upload Notes/Comments">
                <el-input type="textarea" :disabled="disabled" v-loading="descLoading" v-model="docMeta.costDesc" :minlength="3" :maxlength="250" :rows="6"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <br />
          <h4>Justification Documents</h4>
          <p>
            Justification documents should add weight to your business case for this planned expenditure. Examples could include efficiency studies, market analysis etc. <br/>
            You can add multiple Justification Documents to strengthen your business case.
          </p>
          <p v-if="usingIE" class="IEwarn">
            <strong> Please SAVE file when prompted in IE, do not open directly.
            </strong>
          </p>
          <el-row :gutter="20">
            <el-col :span="22">
              <el-form-item class="doc-list">
                <el-upload
                class="doc-upload"
                :disabled="disabled"
                ref="FileUploadJustification"
                v-bind:action="this.apiPath + '/pea/' + this.peaId + '/addDocument/Justification'"
                    :headers="checkReturnAuthHead"
                    v-loading="isJustLoading"
                    :on-success="uploadJustificationSuccess"
                    :on-error="uploadJustificationFailure"
                    :before-upload="startUploadJustification"
                    :on-preview="downloadDocument"
                    :file-list="JustificationDocumentFiles"
                    :on-remove="removeFile">
                  <el-button class="doc-submit"
                  :disabled="isJustLoading || disabled"
                   v-if="!disabled" slot="trigger"
                    type="primary">Select &amp; Upload Justification</el-button>
                </el-upload>
              </el-form-item>
              <strong>{{this.MaxFileSizeMessage}}</strong>
              <br v-if="isJustLoading"/>
              <span v-if="isJustLoading">{{this.justLoadingMessage}}</span>
              <span class="el-icon-loading" v-if="isJustLoading"></span>
              <span v-if="!isJustLoading">&nbsp;</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="justDesc" label="Justification Upload Notes/Comments">
                <el-input type="textarea" :disabled="disabled" v-loading="descLoading" v-model="docMeta.justDesc" :minlength="3" :maxlength="250" :rows="6"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </transition>
  </el-row>
</template>
<script>
import helperMethods from '@/components/utility/helperMethods.js'
import { mapActions } from 'vuex'

export default {
  name: 'pea-documents',
  props: {
    peaId: {
      default: 0
    },
    disabled: {
      default: false
    }
  },
  data () {
    return {
      JustificationDocumentFiles: [],
      CostingDocumentFiles: [],
      DocumentData: [],
      docMeta: {
        justDesc: '',
        costDesc: ''
      },
      descLoading: false,
      isJustLoading: false,
      justLoadingMessage: '',
      isCostLoading: false,
      costLoadingMessage: '',
      loadingType: '',
      apiPath: process.env.VUE_APP_API_SERVER,
      panelOpen: true,
      MaxFileSizeMessage: '',
      usingIE: false,
      rules: {
        justDesc: [
          { min: 3, max: 2000, message: 'Length should be 3 to 2000 characters', trigger: 'blur' }
        ],
        costDesc: [
          { min: 3, max: 2700, message: 'Length should be 3 to 2700 characters', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    checkReturnAuthHead () {
      if (this.$store.state.userInfo.accessToken) {
        return {
          'Authorization': 'Bearer ' + this.$store.state.userInfo.accessToken
        }
      } else {
        // eslint-disable-next-line
        this.getOrSetAuth().then(() => {
          return {
            'Authorization': 'Bearer ' + this.$store.state.userInfo.accessToken
          }
        })
      }
    }
  },
  methods: {
    ...mapActions(['getAccessToken', 'getDataToken', 'getSingleFullAccountData', 'getUserDetails']),
    getOrSetAuth () {
      return new Promise((resolve) => {
        const accounts = this.$msalInstance.getAllAccounts()
        this.$msalInstance.setActiveAccount(accounts[0])
        this.$store.state.userInfo.account = accounts[0]
        this.getDataToken(this.$msalInstance).then(() => {
          this.getSingleFullAccountData(this.$store.state.userInfo.account.username)
            .then(() => {
              this.getUserDetails(this.$store.state.userInfo.fullAccount.onPremisesSamAccountName)
              resolve()
            })
        })
      })
    },
    startup () {
      this.fetchAvailableDocTypes()
      this.refreshFileLists()
      this.fetchMaxFileSize()
      this.checkIE()
    },
    checkFormValidation () {
      this.$refs['documentsForm'].validate((valid) => {
        if (valid) {
          this.$parent.$emit('peaDocumentValidation', true)
        } else {
          this.$parent.$emit('peaDocumentValidation', false)
          helperMethods.showNotification(this.$parent, 'Invalid Document requirements', 'Please check Documents section for invalid inputs.', 'warning', 30000, 'Please check form for invalid inputs.')
        }
      })
    },
    checkIE () {
      var browser = helperMethods.getBrowser()
      if (browser.name === 'MSIE' || browser.name === 'IE') {
        this.usingIE = true
      }
    },
    fetchMaxFileSize () {
      var call = '/ApiInfo/MaxFileSize'
      this.$axios.get(call).then(response => {
        this.maxFileSize = response.data
        this.MaxFileSizeMessage = 'Maximum size of file is ' + response.data
      }).catch(response => {
        helperMethods.showNotification(this.$parent, 'Error retrieving MaxFileSize', response.body, 'error', 30000)
      })
    },
    fetchAvailableDocTypes () {
      var call = '/pea/' + this.peaId + '/getDocumentMetaData'
      this.isJustLoading = true
      this.justLoadingMessage = 'Fetching Justification Documents'
      this.isCostLoading = true
      this.costLoadingMessage = 'Fetching Costing Documents'
      this.$axios.get(call).then(response => {
        this.DocumentData = response.data
        for (var i = 0; i < this.DocumentData.length; i++) {
          if (this.DocumentData[i].documentType === 'Justification') {
            this.docMeta.justDesc = this.DocumentData[i].description
          }
          if (this.DocumentData[i].documentType === 'Costing') {
            this.docMeta.costDesc = this.DocumentData[i].description
          }
        }
      }).catch(response => {
        helperMethods.showNotification(this.$parent, 'Error retrieving DocumentMetaData', response.body, 'error', 30000)
      })
    },
    refreshFileLists () {
      this.isJustLoading = true
      this.justLoadingMessage = 'Fetching Justification Documents'
      this.isCostLoading = true
      this.costLoadingMessage = 'Fetching Costing Documents'
      var call = '/pea/' + this.peaId + '/getDocuments/'
      this.$axios.get(call + 'Justification').then(response => {
        this.JustificationDocumentFiles = response.data
        this.isJustLoading = false
      }).catch(response => {
        helperMethods.showNotification(this.$parent, 'Error retrieving Justifcation docs', response.body, 'error', 30000)
      })
      this.$axios.get(call + 'Costing').then(response => {
        this.CostingDocumentFiles = response.data
        this.isCostLoading = false
        this.$emit('fetchComplete')
      }).catch(response => {
        helperMethods.showNotification(this.$parent, 'Error retrieving Costing docs', response.body, 'error', 30000)
      })
    },
    documentsFormSubmit () {
      this.descLoading = true
      for (var i = 0; i < this.DocumentData.length; i++) {
        if (this.DocumentData[i].documentType === 'Justification') {
          this.DocumentData[i].description = this.docMeta.justDesc
        }
        if (this.DocumentData[i].documentType === 'Costing') {
          this.DocumentData[i].description = this.docMeta.costDesc
        }
      }
      var call = '/pea/' + this.peaId + '/updateDocumentDescriptions'
      return new Promise((resolve, reject) => {
        this.$axios.post(call, this.DocumentData, {emulateJSON: false}).then(response => {
          this.descLoading = false
          resolve(response)
        }).catch(response => {
          helperMethods.showNotification(this.$parent, 'Error Updating Doc Info', response.body, 'error', 30000)
          this.descLoading = false
          reject(response)
        })
      })
    },
    downloadDocument (file) {
      this.isCostLoading = true
      this.isJustLoading = true
      if (file.name.indexOf(' Justification - ') === -1) {
        this.costLoadingMessage = 'Downloading Costing Document'
      } else {
        this.justLoadingMessage = 'Downloading Justification Document'
      }
      this.$axios.get('/documents/getDocumentContents/' + file.id, { responseType: 'blob' }).then(response => {
        if (navigator.msSaveBlob) { // IE 10+
          let blob = new Blob([response.data], { type: response.headers.get('content-type') })
          navigator.msSaveBlob(blob, file.name)
          this.isCostLoading = false
          this.isJustLoading = false
        } else {
          let blob2 = new Blob([response.data], { type: response.headers.get('content-type') })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob2)
          link.setAttribute('download', file.name)
          document.body.appendChild(link)
          link.click()
          this.isCostLoading = false
          this.isJustLoading = false
        }
      })
    },

    uploadCostingSuccess (response, file, fileList) {
      this.uploadSuccess('Costing')
    },
    uploadCostingFailure (err, file, fileList) {
      this.uploadFailure('Costing', err)
    },
    uploadJustificationSuccess (response, file, fileList) {
      this.uploadSuccess('Justification')
    },
    uploadJustificationFailure (err, file, fileList) {
      this.uploadFailure('Justification', err)
    },
    uploadSuccess (documentType) {
      this.isJustLoading = false
      this.isCostLoading = false
      helperMethods.showNotification(this.$parent, 'Success', documentType + ' file uploaded.', 'success', 30000)
      this.refreshFileLists()
    },
    uploadFailure (documentType, err) {
      this.isJustLoading = false
      this.isCostLoading = false
      helperMethods.showNotification(this.$parent, documentType + ' File Error', err.toString(), 'error', 30000)
      this.refreshFileLists()
    },
    startUploadCosting (file) {
      this.startUpload(file, 'Costing')
    },
    startUploadJustification (file) {
      this.startUpload(file, 'Justification')
    },
    startUpload (file, type) {
      var t1 = this.maxFileSize.split(' ')
      var intSize = parseInt(t1[0])
      var isLt4M = parseInt((file.size / 1024) / 1024) < intSize
      if (!isLt4M) {
        this.$notify.error({
          title: 'File Too Large',
          message: 'File cannot exceed ' + this.maxFileSize + '.'
        })
        this.refreshFileLists()
        return false
      } else {
        if (type === 'Justification') {
          this.isJustLoading = true
          this.justLoadingMessage = 'Uploading Justification Document'
        } else {
          this.isCostLoading = true
          this.costLoadingMessage = 'Uploading Costing Document'
        }
      }
    },
    removeFile (file, fileList) {
      if (file.id !== undefined) {
        var documentId = file.id
        if (file.name.indexOf(' Justification - ') === -1) {
          this.isCostLoading = true
          this.costLoadingMessage = 'Deleting Costing Document'
        } else {
          this.isJustLoading = true
          this.justLoadingMessage = 'Deleting Justification Document'
        }
        var call = '/documents/deleteDocument/' + documentId
        this.$axios.delete(call).then(data => {
          this.isJustLoading = false
          this.isCostLoading = false
          helperMethods.showNotification(this.$parent, 'Success', 'File deleted.', 'success', 30000)
          this.refreshFileLists()
        }).catch(response => {
          helperMethods.showNotification(this.$parent, 'Error deleting Doc', response.body, 'error', 30000)
          this.isJustLoading = false
          this.isCostLoading = false
        })
      }
    }
  },
  mounted () {
    this.startup()
  },
  watch: {
    // watch for route change - going from pea/4 to pea/0
    '$route': 'startUp'
  }
}
</script>

<style scoped>
.IEwarn {
  color: rgb(165,0,33);
}
h4 {
  background: #839da2;
  color: #FFF;
  font-size: 1.2rem;
  margin-left: -20px;
  padding: 12px 20px;
  width: 110%;
}

p {
  font-size: 0.96rem;
  line-height: 35px;
  margin-bottom: 0;
}

.el-textarea {
  margin: -10px 0 10px 0;
}

.el-form-item {
  margin-bottom: 0;
}

.el-upload-list__item-name:hover {
  overflow: visible !important;
  white-space: inherit !important;
}

.doc-submit {
  margin: 15px 0 8px 0;
}

.doc-list {
  display: flex;
}

.doc-upload {
  line-height: 0 !important;
  margin-bottom: 20px;
}
</style>
